import { MOMENT_TYPES } from 'utils/constants';

/** Backend id for the legacy Offer / Price Change / Program create flow. */
const LEGACY_MOMENT_TYPE_IDS = new Set(['offer-price-program']);

// OFFER_PRICE_PROGRAM is aliased to PRICE_CHANGES_AND_OFFERS in constants — do not
// include it here or the new create option is incorrectly hidden.
const LEGACY_DISPLAY_NAMES_LOWER = new Set(
  [MOMENT_TYPES.PROMOS_OFFERS, 'Offer, Price Change or Program'].map(s =>
    s.trim().toLowerCase()
  )
);

function normalizeMomentName(name: string): string {
  return name
    .replace(/\s*\(deprecated\)\s*$/i, '')
    .trim()
    .toLowerCase();
}

/** Legacy Offers / Promos types replaced by "Price Changes and Offers" for new RSDs. */
export function isLegacyOfferOrPromoMomentType(type: {
  id: string;
  name: string;
}): boolean {
  if (LEGACY_MOMENT_TYPE_IDS.has(type.id)) return true;
  const n = normalizeMomentName(type.name || '');
  return LEGACY_DISPLAY_NAMES_LOWER.has(n);
}

/** Same rules for dropdown `{ value, label }` rows (value is usually moment type id). */
export function isLegacyOfferOrPromoMomentOption(option: {
  value: string;
  label: string;
}): boolean {
  if (LEGACY_MOMENT_TYPE_IDS.has(option.value)) return true;
  const n = normalizeMomentName(option.label || '');
  return LEGACY_DISPLAY_NAMES_LOWER.has(n);
}
